(function ( $ ) {

	$.fn.navs = function ( options ) {
		var elem = $( this ),
			$body = $( 'body' ),
			$htmlAndBody = $( 'html, body' ),
			classScrolled = 'have-scrolled',
			classNotScrolled = 'have-not-scrolled',
			currWindowScroll = 0,

			$header = $( '.site-head' ),
			$accessibilityOptions = $header.find( '.accessibility-options' ),
			$siteBranding = $header.find( '.site-branding' ),
			$searchDesktop = $header.find( '.search-form--desktop' ),
			$searchMobile = $header.find( '.search-form--mobile' ),
			$btnDonate = $header.find( '.site-head__donate' ),
			$mainNav = $header.find( '.site-head__navigation' ),
			$mainNavLiHaveChildren = $mainNav.find( '.menu-item-has-children' ),

			$subNav = $body.find( '.secondary-menu' ),
			$subNavMainWrapper = $subNav.find( '.wrapper' ),
			subNavInPageLinks = [],
			$subNavLinksInContent,
			$subNavLinksToContent,
			subNavCurrentActiveSectionId,
			subNavAmountVisibleToBeActive = 150, // how many pixels should we see before it's considered an 'active' section?
			subNavSmoothScrollDuration = 750,
			$scrollWrapper,
			subNavExists = $subNav.length > 0,
			subNavOriginalTopOffset = !subNavExists ? 0 : parseInt( $subNav.css( 'top' ) ),

			$blogSearchContainer = $( '.blog-search-form-container' ),
			hasBlogSearchContainer = $blogSearchContainer.length > 0,

			$btnAccessibilityTrigger = $header.find( '.trigger-accessibility-options, .btn--accessibility-options-toggle' ),
			$btnSearchTrigger = $header.find( '.trigger-search' ),

			$btnMobileAccessibilityTrigger = $header.find( '.btn--accessibility-options-toggle' ),
			$btnMobileMenuTrigger = $header.find( '.btn--hamburger' ),
			$btnMobileSubmenuTriggers,

		// When a submenu item is open and we click another one, should the first one close?
			shouldMobileTriggersCloseOthers = true,

			isAccessibilityOpen = false,
			isSearchOpen = false,
			isMainNavOpen = false,


			desktopNavHeightFull = 97,
			desktopNavHeightCondensed = 56,
			desktopAccessibilityHeight = 100,
			desktopSearchHeight = 60;

		var init = function () {


				// Turning off debounced to have quicker "feel"
				// var debouncedCheckTop = debounce( function () {
				// 	areWeAtTop();
				// }, 80 );
				//
				// window.addEventListener( 'scroll', debouncedCheckTop );
				// window.addEventListener( 'resize', debouncedCheckTop );
				$( window ).on( 'scroll resize', areWeAtTop );

				areWeAtTop();


				insertMobileTogglers();

				$btnAccessibilityTrigger.on( 'click', function ( e ) {
					e.preventDefault();

					toggleAccessibilityOptions();
				} );

				$btnSearchTrigger.on( 'click', function ( e ) {
					e.preventDefault();

					toggleSearch();
				} );


				$btnMobileMenuTrigger.on( 'click', function ( e ) {
					e.preventDefault();

					toggleMobileMenu();
				} );

				if ( $btnMobileSubmenuTriggers.length > 0 ) {

					$btnMobileSubmenuTriggers.on( 'click', function ( e ) {
						e.preventDefault();

						toggleMobileSubmenu( $( this ) );
					} );
				}

				if ( subNavExists ) {
					subNavCreateLinks();
					adjustSubNav();
				}

			},

			areWeAtTop = function () {

				var windowScroll = $( window ).scrollTop();

				if ( windowScroll > 0 ) {
					$body.removeClass( classNotScrolled ).addClass( classScrolled );
				} else {
					$body.removeClass( classScrolled ).addClass( classNotScrolled );
				}


			},
			insertMobileTogglers = function () {


				$mainNavLiHaveChildren.each( function ( i, el ) {
					var $toggler = $( '<button class="mobile-nav-toggler"><img class="icon-arrow-down" src="/images/global/icon-mobile-down.svg" /><img class="icon-arrow-up" src="/images/global/icon-mobile-up.svg" /></button>' ).insertAfter( $( this ).find( '> a' ).eq( 0 ) );
				} );


				$btnMobileSubmenuTriggers = $mainNav.find( '.mobile-nav-toggler' );
			},
			toggleAccessibilityOptions = function ( forceClose ) {

				if ( $accessibilityOptions.hasClass( 'is-active' )
					|| ( typeof forceClose != 'undefined' && forceClose == true)
				) {
					// closing
					$accessibilityOptions.removeClass( 'is-active' );

					$body
						.removeClass( 'accessibility-options--open' )
						.addClass( 'accessibility-options--closed' );

					$btnAccessibilityTrigger
						.parents( '.accessibility-link__wrapper' )
						.removeClass( 'is-active' );

					isAccessibilityOpen = false;

					if ( typeof forceClose == 'undefined' || forceClose == false ) {
						turnScrollingBackOn();
					}

				} else {
					$accessibilityOptions.addClass( 'is-active' )

					$body
						.removeClass( 'accessibility-options--closed' )
						.addClass( 'accessibility-options--open' );

					$btnAccessibilityTrigger
						.parents( '.accessibility-link__wrapper' )
						.addClass( 'is-active' );

					isAccessibilityOpen = true;

					if ( CAF.UTILS.areWeMobile() ) {
						preventScroll();
					}
				}


				if ( typeof forceClose == 'undefined' || forceClose == false ) {
					toggleSearch( true );
				}

				adjustSubNav();

			},

			toggleSearch = function ( forceClose ) {

				if ( $searchDesktop.hasClass( 'is-active' )
					|| ( typeof forceClose != 'undefined' && forceClose == true) ) {
					// closing
					$searchDesktop.removeClass( 'is-active' );

					$body
						.removeClass( 'search--open' )
						.addClass( 'search--closed' );

					isSearchOpen = false;


				} else {
					$searchDesktop.addClass( 'is-active' );

					$body
						.removeClass( 'search--closed' )
						.addClass( 'search--open' );

					isSearchOpen = true;

					if(!CAF.UTILS.areWeMobile()) {
						$searchDesktop.find('.search__input').focus();
					}

				}


				if ( typeof forceClose == 'undefined' || forceClose == false ) {
					toggleAccessibilityOptions( true );
				}

				adjustSubNav();

			},

			toggleMobileMenu = function ( forceClose ) {

				if ( $mainNav.hasClass( 'is-active' ) || ( typeof forceClose != 'undefined' && forceClose == true) ) {
					$searchMobile.removeClass( 'is-active' );

					$mainNav.add( $btnMobileMenuTrigger ).add( $btnDonate ).removeClass( 'is-active' );

					$body
						.removeClass( 'mobile-nav--open' )
						.addClass( 'mobile-nav--closed' );

					isMainNavOpen = false;

					$mainNav.css( {
						'max-height' : 0
					} );

					closeAllSubMenus();

					if ( typeof forceClose == 'undefined' || forceClose == false ) {
						turnScrollingBackOn();
					}

				} else {
					$searchMobile.addClass( 'is-active' );

					$mainNav.add( $btnMobileMenuTrigger ).add( $btnDonate ).addClass( 'is-active' );

					$body
						.removeClass( 'mobile-nav--closed' )
						.addClass( 'mobile-nav--open' );

					isMainNavOpen = true;


					var leftoverHeight = $( window ).height() - $siteBranding[ 0 ].scrollHeight - $searchMobile[ 0 ].scrollHeight - ( $btnDonate[ 0 ].scrollHeight + ( 10 * 2 ) );
					$mainNav.css( {
						'max-height' : leftoverHeight
					} );


					if ( CAF.UTILS.areWeMobile() ) {
						preventScroll();
					}
				}

				if ( typeof forceClose == 'undefined' || forceClose == false ) {
					toggleAccessibilityOptions( true );
				}

			},

			toggleMobileSubmenu = function ( $clicked ) {
				var $parentLi = $clicked.parents( 'li' ),
					isOpen = $parentLi.hasClass( 'open' );

				if ( isOpen ) {
					// closing
					$parentLi.add( $clicked ).removeClass( 'open' );
				} else {
					// opening
					$parentLi.add( $clicked ).addClass( 'open' );
				}

				if ( shouldMobileTriggersCloseOthers ) {
					$btnMobileSubmenuTriggers.not( $clicked ).add( $mainNavLiHaveChildren.not( $parentLi ) ).removeClass( 'open' );
				}
			},
			closeAllSubMenus = function () {
				$btnMobileSubmenuTriggers.add( $mainNavLiHaveChildren ).removeClass( 'open' );
			},


			preventScroll = function () {
				currWindowScroll = window.pageYOffset;

				//console.log( 'Freezing scrolling at ', currWindowScroll );

				$body
					.css( {
						position : 'fixed',
						overflow : 'hidden',
						top      : -currWindowScroll,
						width    : '100%'
					} );

				window.scrollTo( 0, currWindowScroll );
			},
			turnScrollingBackOn = function () {
				$body.css( {
					position : 'relative',
					overflow : 'visible',
					top      : 'auto'
				} );

				$( 'html, body' ).scrollTop( currWindowScroll );

				//console.log( 'Turning scrolling back on and jumping to ', currWindowScroll );

			},

		//     _____       _     _   _
		//    / ____|     | |   | \ | |
		//   | (___  _   _| |__ |  \| | __ ___   __
		//    \___ \| | | | '_ \| . ` |/ _` \ \ / /
		//    ____) | |_| | |_) | |\  | (_| |\ V /
		//   |_____/ \__,_|_.__/|_| \_|\__,_| \_/
		//
		//
			adjustSubNav = function () {

				if ( subNavExists ) {

					if ( isSearchOpen ) {
						$subNav.css( {
							top : subNavOriginalTopOffset + desktopSearchHeight
						} );
					} else if ( isAccessibilityOpen ) {
						$subNav.css( {
							top : subNavOriginalTopOffset + desktopAccessibilityHeight
						} );
					} else {
						$subNav.css( {
							top : desktopNavHeightCondensed
						} );
					}

				}

				// This should push the BlogSearch panel below the subnav
				if ( hasBlogSearchContainer ) {
					var subNavHeight = $subNav.outerHeight();


					if ( isSearchOpen ) {
						$blogSearchContainer.css( {
							top : subNavOriginalTopOffset + desktopSearchHeight + subNavHeight
						} );
					} else if ( isAccessibilityOpen ) {
						$blogSearchContainer.css( {
							top : subNavOriginalTopOffset + desktopAccessibilityHeight + subNavHeight
						} );
					} else {
						$blogSearchContainer.css( {
							top : desktopNavHeightCondensed + subNavHeight
						} );
					}
				}
			},

			bindSubNavEvents = function () {
				var debouncedSubNavAdjustScroll = debounce( function () {
					subNavAdjustNeededWidth();
					subNavUpdateScrollPoints();
				}, 250 );

				window.addEventListener( 'resize', debouncedSubNavAdjustScroll );


				var debouncedSubNavAdjustPosition = debounce( function () {
					adjustSubNav();
				}, 150 );
				window.addEventListener( 'scroll', debouncedSubNavAdjustPosition );
				window.addEventListener( 'resize', debouncedSubNavAdjustPosition );

				// first time
				adjustSubNav();


				$subNav.on( 'mouseenter', '.menu-item-has-children', function () {
					if ( $subNav.hasClass( 'contrained' ) || CAF.UTILS.areWeMobile() ) {
						subNavMobileCloneSubmenu( $( this ) );
					}
				} )
					.on( 'mouseleave', '.menu-item-has-children', function () {
						$body.find( '.sub-menu-clone' ).remove();
					} );

				if ( $subNavLinksToContent.length > 0 ) {

					// Leaving in case.. but decide to not debounce..
					// otherwise, they weren't updating during scroll,
					// only after the user stoppped. Could seem unresponsive
					//
					// var debouncedSubNavActiveLinkAdjust = debounce( function () {
					// 	subNavSetActiveScrollPoints();
					// }, 150 );
					// window.addEventListener( 'scroll', debouncedSubNavActiveLinkAdjust );

					$( window ).on( 'scroll', subNavSetActiveScrollPoints );
					subNavSetActiveScrollPoints();


					$subNavLinksToContent.on( 'click', function ( e ) {
						var idToScrollTo = $( this ).data( 'jump-to' );
						if ( idToScrollTo ) {
							subNavSmoothScroll( idToScrollTo, e );
						}
					} );
				}
			},

			subNavCreateLinks = function () {

				$subNavLinksInContent = $body.find( '.sub-nav-target' );

				var $links = $();

				$subNavLinksInContent.each( function ( i, el ) {
					var $this = $( this ),
						title = $this.text(),
						id = CAF.UTILS.makeSafeForCss( title );


					var currLinkHtml = '<li class="secondary-menu__item secondary-menu__item--jump-nav" data-jump-to="' + id + '"><a href="#' + id + '">' + title.trim() + '</a></li>';

					$this.attr( 'id', id );

					$links = $links.add( $( currLinkHtml ) );

					subNavInPageLinks.push( {
						id        : id,
						offsetTop : -1,
						$target   : $this
					} );

				} );

				if ( $links.length > 0 ) {
					$subNav.find( '.secondary-menu__list' ).append( $links );

					$subNavLinksToContent = $links.slice();

					// Mobile browsers were trying to find the offsets too soon
					// Waiting for the page to be fully loaded
					$( window ).load( function () {
						subNavUpdateScrollPoints();
					} );
				}


				$scrollWrapper = $subNav.find( '.secondary-menu__list' ).add( $subNav.find( '.secondary-menu__action' ) ).wrapAll( '<div class="scroll-wrapper" />' ).parent();
				// Whether we have jump links or not.. we might have links added through PHP (archive dropdowns, for instance)
				subNavAdjustNeededWidth();

				bindSubNavEvents();
				$subNav.prepend( '<div class="fade-holder"><div class="scroll-fade scroll-fade-left" /><div class="scroll-fade scroll-fade-right" /></div>' );
			},

			subNavAdjustNeededWidth = function () {

				//console.log( 'Adjusting $subnav width' );
				var allWidths = 0,
					$clone = $scrollWrapper.clone().appendTo( 'body' ).css( {
						'position' : 'fixed',
						'top'      : -9999,
						'width'    : 9999
					} );

				$subNav.find( '.secondary-menu__list' ).find( '.secondary-menu__item' ).add( $subNav.find( '.secondary-menu__action' ) ).each( function ( i, el ) {
					allWidths = allWidths + $( this ).outerWidth( true );
				} );

				if ( $( window ).width() < ( allWidths + 40) ) {
					$scrollWrapper.width( allWidths + 30 );
					$subNav.removeClass( 'flexible' ).addClass( 'constrained' );
				} else {
					$scrollWrapper.css( {
						width : 'auto'
					} );
					$subNav.removeClass( 'constrained' ).addClass( 'flexible' );
				}

				$clone.remove();

			},
			subNavMobileCloneSubmenu = function ( $hovered ) {

				var hoveredOffset = $hovered.offset(),
					hoveredHeight = $hovered.outerHeight(),
					$subMenu = $hovered.find( '.sub-menu' );

				var $subMenuClone = $subMenu.clone().appendTo( $body );

				$subMenuClone.addClass( 'sub-menu-clone' ).css( {
					position : 'absolute',
					top      : hoveredOffset.top + hoveredHeight - 1,
					left     : hoveredOffset.left,
					display  : 'inline-block',
					zIndex   : 999
				} );

			},

			subNavUpdateScrollPoints = function () {

				// No use in going forward if there aren't any
				if ( subNavInPageLinks.length < 1 ) {
					return;
				}


				for ( var i = 0; i < subNavInPageLinks.length; i++ ) {
					var $target = subNavInPageLinks[ i ][ '$target' ];

					if ( $target.length < 1 ) {
						subNavInPageLinks[ i ][ 'offsetTop' ] = -1;
					} else {
						subNavInPageLinks[ i ][ 'offsetTop' ] = Math.floor( $target.offset().top );
					}

				}

			},
			subNavSetActiveScrollPoints = function () {
				// No use in going forward if there aren't any
				if ( subNavInPageLinks.length < 1 ) {
					return;
				}


				var bottomOfCurrWindow = $( window ).scrollTop() + $( window ).height(),
					destinationId = '',
					$activeSubNavLink;

				// Using a backwards loop to check the highest / most offset-est that is within the scren
				for ( var i = subNavInPageLinks.length; i--; ) {

					if ( ( subNavInPageLinks[ i ][ 'offsetTop' ] + subNavAmountVisibleToBeActive) <= bottomOfCurrWindow ) {

						destinationId = subNavInPageLinks[ i ][ 'id' ];
						$activeSubNavLink = $subNavLinksToContent.filter( '[data-jump-to="' + destinationId + '"]' );

						break;
					}

				}

				// console.table( subNavInPageLinks );
				// console.log( destinationId, $activeSubNavLink.text(), bottomOfCurrWindow, ( subNavInPageLinks[ i ][ 'offsetTop' ] + subNavAmountVisibleToBeActive), bottomOfCurrWindow );


				if ( subNavCurrentActiveSectionId != '' && subNavCurrentActiveSectionId != destinationId ) {

					$subNavLinksToContent.not( $activeSubNavLink ).removeClass( 'is-active' );

					if ( $activeSubNavLink.length > 0 ) {
						$activeSubNavLink.addClass( 'is-active' );
					}

					subNavCurrentActiveSectionId = destinationId;


					// On mobile, let's scroll the active element into view if it isn't


					var windowWidth = $( window ).width(),
						wrapperScroll = $subNavMainWrapper.scrollLeft(),
						activeLinkLeft = $activeSubNavLink.offset().left,
						activeLinkPositionLeft = $activeSubNavLink.position().left,
						activeLinkWidth = $activeSubNavLink.outerWidth( true ),
						activeLinkRightEdge = activeLinkLeft + activeLinkWidth;

					if ( activeLinkLeft < 0 || activeLinkRightEdge > windowWidth ) {
						$subNavMainWrapper.animate( {
							scrollLeft : activeLinkPositionLeft - ( activeLinkWidth / 2 )
						}, 500 );
					}

					//console.log( $activeSubNavLink.find( 'a' ).text(), $activeSubNavLink.offset().left, activeLinkWidth / 2, $subNavMainWrapper.scrollLeft() )
				}
			},
			subNavSmoothScroll = function ( targetId, event ) {
				var $target = $body.find( '#' + targetId );

				if ( event ) {
					event.preventDefault();
				}

				if ( $target.length > 0 ) {
					$htmlAndBody.stop().animate( {
						scrollTop : $target.offset().top - $header.outerHeight() - $subNav.outerHeight() - 10
					}, subNavSmoothScrollDuration, 'swing', function () {

						// Change the hash without updating (and making it jump)
						// http://lea.verou.me/2011/05/change-url-hash-without-page-jump/
						if ( history.pushState ) {
							history.pushState( null, null, '#' + targetId );
						}
						else {
							location.hash = '#' + targetId;
						}
					} );
				}

			};

		init();
		return this;
	};

}( jQuery ));
